import { DataV2 } from 'bones/utils/queryBuilder/migrate/v2/types';
import {
  ConjunctionV3,
  OperatorTypeV3,
} from 'bones/utils/queryBuilder/migrate/v3/constants';
import {
  DataV3,
  ExpressionV3,
  FilterV3,
  TopExpressionV3,
} from 'bones/utils/queryBuilder/migrate/v3/types';

export const v3 = (data: DataV2): DataV3 => ({
  ...data,
  query: {
    conjunction: data.query.conjunction as unknown as ConjunctionV3,
    expressions: data.query.expressions.map((subExpression) => ({
      conjunction: subExpression.conjunction as unknown as ConjunctionV3,
      expressions: subExpression.expressions.map(
        (expression) =>
          ({
            filters: expression.filters.map((filter) => {
              const { isDatatype, ...operator } = filter.operator;
              return {
                ...filter,
                operator: {
                  ...operator,
                  operatorType: isDatatype
                    ? OperatorTypeV3.DATATYPE
                    : OperatorTypeV3.OBJECT,
                },
              } as unknown as FilterV3;
            }),
          } as ExpressionV3)
      ),
    })),
  } as TopExpressionV3,
});
